import React from 'react';
import { Paragraph } from 'common-components/typography';
import SpinningLoader from 'common-components/loading/SpinningLoader';
import _ from 'lodash';

export const AssignWorkerStep1 = () => {
  return (
    <>
      <Paragraph>
        Which support worker would you like to assign to this <b>booking</b>?
      </Paragraph>
      <div className='mt-x5-large'>
        <SpinningLoader size={150} message={'Fetching support worker data ...'} />
      </div>
    </>
  );
};
